var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrolley(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1101 4.34873H10.89L13.195 2.0061L12.205 1L8.91007 4.34873H6.4C5.6268 4.34873 5 4.98576 5 5.77157V18.5772C5 19.363 5.6268 20 6.4 20H7.8L8.5 18.5772H15.5L16.2 20H17.6C18.3732 20 19 19.363 19 18.5772V5.77157C19 4.98576 18.3732 4.34873 17.6 4.34873H15.09L17.395 2.0061L16.405 1L13.1101 4.34873ZM17.6 12.8858H6.4V5.77157H17.6V12.8858ZM16.2 17.1543C15.4272 17.1543 14.8 16.5169 14.8 15.7315C14.8 14.9461 15.4272 14.3086 16.2 14.3086C16.9728 14.3086 17.6 14.9461 17.6 15.7315C17.6 16.5169 16.9728 17.1543 16.2 17.1543ZM7.8 17.1543C7.0272 17.1543 6.4 16.5169 6.4 15.7315C6.4 14.9461 7.0272 14.3086 7.8 14.3086C8.5728 14.3086 9.2 14.9461 9.2 15.7315C9.2 16.5169 8.5728 17.1543 7.8 17.1543Z",
    fill: "#C48900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrolley);
export default __webpack_public_path__ + "static/media/trolley.bf8d963ba36e1f10acdbb5607adfe13c.svg";
export { ForwardRef as ReactComponent };